import { getContainer } from '@mews-commander/legacy-app-instance';
import { DateTimeUtcService } from '@mews/framework';

/** @deprecated use useAppClockService */
const getAppNowDateTimeUtc = () => {
    const container = getContainer();
    const { appClockComponent } = container();

    return appClockComponent.getAppNowUtc();
};

let timestamp: number | null = null;
let nowUtc: string | null = null;

/** @deprecated use useAppClockService */
export const getNowUtc = (): string => {
    const now = window.performance.now();
    if (!nowUtc || !timestamp || now > timestamp + 1000) {
        timestamp = now;
        nowUtc = DateTimeUtcService.toISOString(getAppNowDateTimeUtc());
    }

    return nowUtc;
};
